import React from 'react'
import { Element } from 'react-bulma-components'
import Duration from './duration'

interface MissionWeekDurationProps {
  duration: number
  expectedDuration?: number
}

const MissionWeekDuration: React.FC<MissionWeekDurationProps> = ({
  duration,
  expectedDuration,
}) => {
  return (
    <>
      <Duration duration={duration} />
      {expectedDuration ? (
        <>
          &nbsp;/&nbsp;
          <Duration duration={expectedDuration} />
        </>
      ) : undefined}
    </>
  )
}

/**
 * Shared display for weekly duration (total + optional expected when mismatch).
 * Used by work-periods and schedule-template editors for consistent styling.
 */
export const WeekDurationDisplay: React.FC<{
  total: number
  expected?: number
}> = ({ total, expected }) => {
  const durationMismatch = expected !== undefined && total !== expected
  return (
    <Element
      renderAs="span"
      textColor={total === 0 ? 'grey' : durationMismatch ? 'danger' : undefined}
      data-tooltip={durationMismatch ? 'La durée ne respecte pas le contrat.' : undefined}
    >
      <MissionWeekDuration
        duration={total}
        expectedDuration={durationMismatch ? expected : undefined}
      />
    </Element>
  )
}
